import OrderProductsSorterBuilder, {
  OrderProductsSorter,
  OrderProductsSorterSortParams,
} from './OrderProductsSorterBuilder';

class OrderProductsSorterCategory extends OrderProductsSorterBuilder {
  public sort<T extends OrderProductsSorter>({
    orderProducts,
  }: OrderProductsSorterSortParams<T>): T[] {
    return orderProducts.sort((a, b) => {
      const itemA = a.category;
      const itemB = b.category;
      if (itemA && itemB) {
        const nameA = itemA.parent?.name ?? itemA.name;
        const nameB = itemB.parent?.name ?? itemB.name;
        return nameA?.localeCompare(nameB);
      }
      return 0;
    });
  }
}

export default OrderProductsSorterCategory;
